import { io, Socket } from 'socket.io-client';
import {
  getAuthTokenFromLocalStorage,
  getAuthUserFromLocalStorage,
} from '../helper';

let socket: Socket | null = null;

export const getSocket = (enableAdminNode = false): Socket => {
  if (!socket) {
    const baseUrl = process.env.REACT_APP_TUTOPIYA_BASE_URL_V2;

    if (!baseUrl) {
      throw new Error('REACT_APP_TUTOPIYA_BASE_URL is not defined');
    }

    socket = io(baseUrl, {
      autoConnect: false,
      auth: {
        token: getAuthTokenFromLocalStorage(),
        adminMode: enableAdminNode,
        userId: getAuthUserFromLocalStorage()?._id || '',
      },
      transports: ['websocket'],
    });
  }
  return socket;
};

export const disconnect = (): void => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
